export function findWorkspaceMatches(draft,labels,find,replace,caseSensitive=false,wholeWord=false){
  if(!find.trim())return [];
  const escaped=find.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
  const expression=new RegExp(wholeWord?`(?<![\\p{L}\\p{N}_])${escaped}(?![\\p{L}\\p{N}_])`:escaped,caseSensitive?'gu':'giu');
  const fields=[...new Map(labels.map(label=>[label.key,label])).values()].map(label=>({kind:'text',key:label.key,label:label.label,before:draft.texts[label.key]??label.fallback}));
  for(const block of draft.blocks)for(const [key,label] of [['title','Заголовок'],['text','Текст'],['button','Кнопка'],['alt','Описание фото']])fields.push({kind:'block',id:block.id,key,label:`${block.title||'Добавленный блок'} · ${label}`,before:block[key]||''});
  return fields.flatMap(field=>{
    const before=String(field.before??''),count=[...before.matchAll(expression)].length;
    if(!count)return [];
    const after=before.replace(expression,()=>replace);
    const limit=field.kind==='text'?300:field.key==='text'?4000:field.key==='button'?90:180;
    return [{...field,before,after,count,valid:after.length<=limit&&(field.kind!=='text'||!!after.trim())}];
  });
}
export function applyWorkspaceMatches(draft,rows){
  for(const row of rows){
    if(!row.valid)continue;
    if(row.kind==='text')draft.texts[row.key]=row.after;
    else{const block=draft.blocks.find(block=>block.id===row.id);if(block)block[row.key]=row.after;}
  }
}
